import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import type { PreparedStarterInfo } from '@racemap/utilities/functions/timing';
import type { FC } from 'react';
import type { Column } from '../TableBody';
import { Cell } from './BasicCell';

interface Props {
  starterInfo: PreparedStarterInfo;
}

const LiveStateColComponent: FC<Props> = ({ starterInfo }) => {
  return (
    <Cell>
      <RingContainer>
        {starterInfo.online && <RingRing />}
        <Circle
          title="live"
          online={starterInfo.online}
          data-toggle="tooltip"
          data-placement="top"
        />
      </RingContainer>
    </Cell>
  );
};

export function getLiveStateCol(): Column {
  return {
    key: 'live',
    title: 'Live',
    width: 40,
    sorter: (a: PreparedStarterInfo, b: PreparedStarterInfo) =>
      Number(b?.online) - Number(a?.online),
    render: function renderer(row: PreparedStarterInfo) {
      return <LiveStateColComponent starterInfo={row} />;
    },
  };
}

const RingContainer = styled.div`
  position: relative;
`;

const RingRing = styled.div`
  border: 3px solid ${RacemapColors.LightGreen};
  border-radius: 30px;
  -webkit-border-radius: 30px;
  height: 20px;
  width: 20px;
  position: absolute;
  left: 0px;
  top: -10px;
  animation: pulsate 2s ease-out;
  -webkit-animation: pulsate 2s ease-out;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  opacity: 0;

  @-webkit-keyframes pulsate {
    0% {
      -webkit-transform: scale(0.1, 0.1);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      -webkit-transform: scale(0.9, 0.9);
      opacity: 0;
    }
  }
  @keyframes pulsate {
    0% {
      transform: scale(0.1, 0.1);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: scale(0.9, 0.9);
      opacity: 0;
    }
  }
`;

const Circle = styled.div<{ online: boolean }>`
  width: 10px;
  height: 10px;
  background-color: ${(props) => (props.online ? RacemapColors.BaseGreen : RacemapColors.LightGray)};
  border-radius: 50%;
  position: absolute;
  top: -5px;
  left: 5px;
`;
